import {Component, OnChanges, OnInit} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {AuditLogVO} from '../../../generate/AuditLogVO';

@Component({
  selector: 'lib-user-audit-log',
  templateUrl: './user-audit-log.component.html',
  styleUrls: ['./user-audit-log.component.scss']
})
export class UserAuditLogComponent implements OnChanges, OnInit {

  auditLog: AuditLogVO[];

  constructor(private userService: UserService) {
  }

  ngOnChanges(changes: any): void {

  }

  ngOnInit() {
    this.userService.retrieveCurrentUserAuditLog().subscribe(data => {
      this.auditLog = data;
    }, error => {
      console.log(error);
    })
  }

}
